module.exports = __webpack_public_path__ + "static/media/down-arrow.1e8823b2.svg";